import { API_URL } from "config";
import Http from "util/https";
import { OrderHistory, OrderResponse, OrderResponseApi, SearchApiParams } from "../types";
import { convertUTCToDate, orderStatusFromNumber } from "../utils/common";

// const res: {data: OrderResponseApi} = {
//   data: {
//     total: 15,
//     order_infos: [{
//       order_status: 0,
//       order_no: "AA1234567899-01",
//       order_build_no: "0000_20250303101030",
//       item_cd: "000001",
//       jan_cd: "0000000000001",
//       client_cd: "000001",
//       store_cd: "0001",
//       store_name: "美女木店",
//       store_stock: 1000,
//       is_client: false,
//       supply_type: 10000,
//       vendor_cd: "000001",
//       vendor_name: "ﾌﾞﾘﾁﾞｽﾄﾝ",
//       class_name: "タイヤ",
//       brand: "WH",
//       item_name: "WH STA",
//       size: "185/65R15H",
//       maker_item_cd: "-",
//       order_quantity: 2000,
//       shipping_quantity: 1980,
//       is_request_to_admin: true,
//       unit_base_price: 10000,
//       unit_cost_price: 15000,
//       unit_sale_price: 20000,
//       order_date: "2025-03-03",
//       desired_date: "2025-04-04",
//       shipping_date: "2025-04-01",
//       shipping_scheduled: "2025-04-01",
//       arrival_date: "2025-04-04",
//       client_doc_no: "-",
//       is_set_order: true,
//       is_staggered: true,
//       is_customer_order: false,
//       is_direct_shipping: false,
//       is_direct: false,
//       author: "鈴木 太郎",
//       approver: '佐藤 花子',
//       shipping_dest_cd: "000001",
//       shipping_dest_zip: "012-3456",
//       shipping_dest_address: "埼玉県戸田市美女木北２－１－１７",
//       shipping_dest_tel: "000-0000-0000",
//       order_store_fax: "000-0000-0001",
//       shipping_dest_name: "美女木店",
//       memo: "店舗メモです",
//       remarks: "本部メモです",
//     }],
//   }
// };

// const oList: OrderResponse[] = res.data.order_infos.map((o, i) => {
//   const order = structuredClone(o);
//   if (order.order_no) order.order_no = [`${i}`.padStart(4, '0'), order.order_no.split('_')[1]].join('_');
//   return order;
// })
// res.data.order_infos = oList;

/**
 * 本部用注文履歴一覧Api
 * @param params 注文商品一覧Apiのパラメータ
 * @returns orderList
 */
export default async function orderHistoryListApi(params: SearchApiParams) {
  const http = Http.default.alterAuth({useToken: true});
  const url = `${API_URL}/order/list/select`;
  const res = await http.post<OrderResponseApi>(url, params);

  const orderList: OrderHistory[] = res.data.order_infos.map((o,i) => ({
    id: (params.offset ?? 0) + i+1,
    orderNumber: o.order_no || o.order_build_no || '', // historyなので採番されているはず。
    productCd: o.item_cd ?? '',
    janCd: o.jan_cd ?? '',
    shopName: o.store_name ?? '',
    orderStatus: orderStatusFromNumber(o.order_status),
    supplierName: o.supplier_name ?? '',
    classification: o.class_name ?? '',
    brand: o.brand_name ?? '',
    productName: o.item_name ?? '',
    size: o.size ?? '',
    productNumber: o.item_num ?? '',
    orderCount: o.order_quantity || 0,
    deliveryCount: o.shipping_quantity || 0,
    headquartersCost: o.shipping_quantity ? o.unit_base_price * o.shipping_quantity : (o.unit_base_price * o.order_quantity || 0),
    headquartersUnitCost: o.unit_base_price || 0,
    wholesalePrice: o.shipping_quantity ? o.unit_cost_price * o.shipping_quantity : (o.unit_cost_price * o.order_quantity || 0),
    wholesaleUnitPrice: o.unit_cost_price || 0,
    shopPrice: o.shipping_quantity ? o.unit_sale_price * o.shipping_quantity : (o.unit_sale_price * o.order_quantity || 0),
    shopUnitPrice: o.unit_sale_price || 0,
    orderDate: convertUTCToDate(o.order_date),
    deliveryDate: convertUTCToDate(o.desired_date),
    shippingDate: convertUTCToDate(o.shipping_date),
    expectedShippingDate: convertUTCToDate(o.shipping_scheduled),
    arrivalDate: o.arrival_date,
    clientBillNumber: o.client_doc_no ?? '',
    isCustomerOrder: o.is_customer_order ?? false,
    isDirectOrder: o.is_direct ?? false,
    shopRemarks: o.memo ?? '',
    headquartersRemarks: o.remarks ?? '',
  }));

  // await new Promise<void>((resolve) => {setTimeout(resolve, 1500)});
  console.log(res);
  // return res.data;
  return {
    total: res.data.total,
    orders: orderList
  };
}